import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $el: this.el
    };
  }

  addListeners() {
    this.dom.$el.addEventListener('click', this.openMarketoModal.bind(this));
  }

  openMarketoModal(event) {
    // set the Marketo button to its disabled state
    this.dom.$el.classList.add('btn--disabled');
    this.dom.$el.blur(); // necessary when used in Optimizely CMS to change state

    event.preventDefault();

    // get Storybook values
    const modal = document.querySelector('.marketo-modal');
    const modalTitleContainer = modal?.querySelector('.modal-title');
    const modalDescriptionContainer = modal?.querySelector('.modal-description');
    const formContainer = modal?.querySelector('.marketo-modal-form__container');

    // get Optimizely CMS values (or use defaults if not available)
    const { dataset } = event.target;
    const formTitle = dataset.formTitle || "";
    const formDescription = dataset.formDescription || "";
    const { formId = 3024, accountId = "335-QLG-882" } = dataset;

    // set modal title
    if (modalTitleContainer) {
      modalTitleContainer.textContent = formTitle;
      modalTitleContainer.setAttribute('aria-label', formTitle);
      formContainer.setAttribute('aria-labelledby', modalTitleContainer.id);
    };

    // set modal description
    if (modalDescriptionContainer) {
      modalDescriptionContainer.textContent = formDescription;
      formContainer.setAttribute('aria-describedby', modalDescriptionContainer.id);
    };

    // create the markup for the Marketo form and insert it into the handlebars container
    formContainer.innerHTML = `<form id="mktoForm_${formId}" class="marketo-modal-form"></form>`;

    // check that the MktoForms2 instance is available prior to loading the Marketo form data.
    // if it is, load the Marketo form data
    if (typeof MktoForms2 !== 'undefined') {
      this.loadMarketoForm(accountId, formId);
    // if it is not, load the MktoForms2 script dynamically, and then load the Marketo form data
    } else {
      const script = document.createElement('script');
      script.src = "//info.amwell.com/js/forms2/js/forms2.min.js";
      script.onload = () => this.loadMarketoForm(accountId, formId);
      document.head.appendChild(script);
    }

    // display the Marketo modal
    modal.classList.add('marketo-modal__expanded');
  }

  loadMarketoForm(accountId, formId) {
    if (typeof MktoForms2 === "undefined") {
      return;
    }

    // eslint-disable-next-line no-undef
    MktoForms2.loadForm("//info.amwell.com", accountId, formId, (form) => {
      // add right-facing chevron svg into the form's button
      const svgElem = `
        <svg viewBox="0 0 8 12" role="presentation" aria-hidden="true">
          <use xlink:href="#chevron-right"></use>
        </svg>`;
      const submitButton = form.getFormElem().find('button[type="submit"]');

      if (submitButton.length > 0) {
        submitButton.append(svgElem);
      }
    });
  }
}

export default Module;
